var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"g-imContainer"},[_c('div',{staticClass:"m-left"},[_c('slideBar')],1),_c('div',{staticClass:"m-right"},[_c('chatMain',{ref:"main"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }